import { render } from "./Multiselect.vue?vue&type=template&id=1981efac&scoped=true"
import script from "./Multiselect.vue?vue&type=script&lang=ts"
export * from "./Multiselect.vue?vue&type=script&lang=ts"

import "./Multiselect.vue?vue&type=style&index=0&id=1981efac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1981efac"

export default script